import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { NgbActiveModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { from, Observable, of, OperatorFunction } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxUserPermission } from 'src/app/core/PDxUserPermission.enum';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { CloneService } from 'src/app/core/services/clone.service';
import { UserInformation } from 'src/app/core/user-properties/user-information.model';
import { EntityAssignmentInformation } from '../models/entity-assignment-information.model';

@Component({
  selector: 'app-view-entity-assignment',
  templateUrl: './view-entity-assignment.component.html',
  styles: [
  ]
})
export class ViewEntityAssignmentComponent implements OnInit {

  @Input() entityId: string;
  @Input() hierarchy: PDxListItem<string>[];
  @Input() userId: string;
  @ViewChild(NgForm) assignmentForm: NgForm;

  stepNumber: number = 1;
  assignment: EntityAssignmentInformation = new EntityAssignmentInformation();
  submitAttempt: boolean = false;

  permissionOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
  };

  permissions: PDxListItem<PDxUserPermission>[] = PDxLists.PDxUserPermissions();

  constructor(private dirtyService: DirtyTrackingService,
    private cloneService: CloneService,
    private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.assignment.entityId = this.entityId;
    this.assignment.hierarchy = this.hierarchy;
    if (this.userId) {
      this.getAssignment(this.userId, () => {
        this.stepNumber = 4;
      });
    }
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  searchedEmails: PDxListItem<string>[] = [];
  searchEmailAddress: OperatorFunction<string, readonly PDxListItem<string>[]> = (text$: Observable<string>) => {
    this.searchedEmails = [];
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => { }),
      switchMap(term => {
        if (!term) {
          return of([]);
        }
        return from(this.ajax.MakeCall<PDxListItem<string>[]>('/User/Search', { query: term }, false)).pipe(
          map((x: PDxListItem<string>[]) => {
            this.searchedEmails = x;
            return x;
          }),
          catchError(() => {
            return of([]);
          }))
      }),
      tap(() => { }),
    )
  };

  formatter = (result: PDxListItem<string>) => result.text;

  getAssignment(userId: string, callback: () => any): void {
    this.ajax.MakeCall<EntityAssignmentInformation>('/User/GetAssignment', { userId: userId, entityId: this.entityId }).then((data) => {
      this.assignment = data;
      callback();
    }, () => { });
  }

  selectEmailAddress(ev: NgbTypeaheadSelectItemEvent<PDxListItem<string>>): void {
    this.getAssignment(ev.item.value, () => {
      this.nextStep();
    });
  }

  previousStep(): void {
    switch (this.stepNumber) {
      case 3: // pick entity
        if (this.assignment.user.userId) { // picked an actual user - go to email address
          this.stepNumber = 1;
          this.assignment.user = new UserInformation();
        } else {
          this.stepNumber = 2;
        }
        break;
      case 4:
        // do nothing
        break;
      default:
        this.stepNumber--;
        break;
    }
  }

  nextStep(): void {
    this.submitAttempt = false;
    switch (this.stepNumber) {
      case 1: // select email address
        if (this.assignment.user.userId) {
          // picked an email address - move on to step 3
          this.stepNumber = 3;
        } else {
          // typed an email address - get user info in step 2
          if (!this.assignmentForm.valid) {
            this.submitAttempt = true;
            return;
          }

          if ((this.searchedEmails.length == 1) && (this.searchedEmails[0].text == this.assignment.user.emailAddress)) {
            // was only one item in the list which matches what the user typed, but the user didn't select it
            this.getAssignment(this.searchedEmails[0].value, () => {
              this.nextStep();
            });
            return;
          } else {
            this.stepNumber = 2;
            this.assignment.user.isActive = true;
            this.assignment.user.isPDxAdmin = false;
          }
        }
        break;
      case 2: // new user profile
        if (!this.assignmentForm.valid) {
          this.submitAttempt = true;
          return;
        }
        this.stepNumber = 3;

        break;
    }
  }

  saveAssignment(): void {
    if (!this.assignmentForm.valid) {
      this.submitAttempt = true;
      return;
    }
    this.ajax.MakeCall<boolean>('/User/SaveAssignment', this.assignment).then((data) => {
      this.modal.close();
    }, () => { });

  }

  /*
    getAssignment(): void {
      if(this.assignment.user){
      this.ajax.MakeCall<EntityAssignmentInformation>('/User/GetAssignment', { userId: this.assignment.user.userId, entityId: this.entityId }).then((data) => {
        this.assignment = data
      }, () => { });
    }
    }
  */
}
